import { FechaFunctionsService } from '@/utils/functions.service';
import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss']
})
export class DatepickerComponent implements OnInit {
  @Input() control: AbstractControl = new FormControl();
  @Input() label: string = "";
  @Input() idForm: string;
  @Input() size: string = "";
  @Input() placeholder: string = "DD/MM/YYYY";
  @Input() cssClass: string = "";
  @Input() readOnly: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() hideIcon: boolean = false;
  @Input() activateButton: boolean = false;
  @Input() minDate: Date = null;
  @Input() maxDate: Date = null;
  @Input() bsValue: Date;
  @Input() horizontal: boolean = false;
  @Input() withTime: boolean = false;
  @Output() valueChange = new EventEmitter();

  constructor(private localeService: BsLocaleService,
    private Func: FechaFunctionsService ) {
  }

  ngOnInit(): void {
    this.localeService.use('es');
  }

  onValueChange(newDate: Date) {
    if (typeof newDate === 'undefined') {
      this.control.setValue(null);
      return
    }
    const datepipe: DatePipe = new DatePipe('en-US')
    let fecha = datepipe.transform(newDate.toISOString(), this.withTime ? 'dd/MM/yyyy H:mm' : 'dd/MM/yyyy');
    this.control.setValue(fecha);
    this.valueChange.emit(newDate);
  }

  sumarDias(days)
  {
    this.bsValue = this.Func.addDays(this.Func.DateFormatedBDTimeZero(this.bsValue.toString()),days);
  }
}
